module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-progress",
    class: {
      'uk-progress-mini': _vm.size == 'mini',
        'uk-progress-small': _vm.size == 'small',
        'uk-progress-striped': _vm.striped,
        'uk-progress-success': _vm.color == 'success',
        'uk-progress-warning': _vm.color == 'warning',
        'uk-progress-danger': _vm.color == 'danger'
    }
  }, [_c('div', {
    staticClass: "uk-progress-bar",
    style: ({
      width: _vm.value + '%'
    })
  }, [(_vm.showValue) ? _c('span', [_vm._v(_vm._s(_vm.value) + "%")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1aa96cc5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UkProgress.vue
// module id = 280
// module chunks = 2